/* 🤖 this file was generated by svg-to-ts */
export const matIconFilter: {
  name: 'filter';
  data: string;
} = {
  name: 'filter',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m15.96 10.29-2.75 3.54-1.96-2.36L8.5 15h11l-3.54-4.71zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"/></svg>`
};
